<template>
  <transition name="fade" mode="out-in">
    <div v-if="visible" class="small-modal" @click.self="hide(false)">
        <div class="modal-container">
            <div class="card-header">
                <h4>Ändra granskare för markerade artiklar</h4>
            </div>
            <div class="card-body bg-white">
                <div class="form-group col-12">
                    <label>{{ $t('client_auditor') }}</label>
                    <Select2 v-model="client_auditors" :options="external_users" :settings="{ multiple: true, theme: 'classic'}" />
                </div>
                <p class="text-danger px-3">OBS! Kundgranskare kommer ändras för samtliga markerade artiklar!</p>
            </div>
            <div class="card-footer text-right">
                <button class="btn text-danger" @click="hide(false)" >Avbryt</button>
                <button class="btn btn-success" @click="saveAuditor">Spara</button>
            </div>
        </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios";

export default {
    props: [
        'printableIds',
        'externAuditorModal',
        'company'
    ],

    data() {
        return {
            client_auditors:[],
            errors: [],
            visible: false,
        }
    },

    watch: {
        externAuditorModal (n,o) {
            if (this.externAuditorModal && !this.visible) this.show()
            else if (!this.externAuditorModal && this.visible) this.hide(false)
        },
    },
    mounted() {
        this.fetchUsers();
    },
    computed : {
        internal_users(){
            return this.users.filter(user => user.role >= 3);
        },
        external_users(){
          return this.users.filter(user => user.role < 3);
        }
    },
    

    methods: {
        async fetchUsers(){
            if(this.company){
                var query = "?include_admins=true&company_id=" + this.company;

                const { data } = await axios.get("/api/user" + query);

                let new_data = data.map(user => {
                    user.text = user.name;
                    return user 
                })

                this.users = new_data;
            }
        },

        hide(reload) {
            this.visible = false;
            this.$emit('modal', reload);
        },
        show() {
            this.visible = true;
        },
        async saveAuditor() {
            let params = {
                printable_ids: this.printableIds,
                client_auditors: this.client_auditors,
            }

            const { data } = await axios.post('/api/printable/extern-auditor',params);
            this.hide(true);
        },
    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/EditExternAuditorModal.vue